/**
 * Converts seconds to hours and minutes
 * @param seconds Seconds value
 * @returns An object with hours and minutes
 */
export const getHoursAndMinutes = (seconds: number) => {
  const totalMinutes = seconds / 60;
  const hours = Math.floor(totalMinutes / 60) || 0;
  const minutes = Math.round(totalMinutes - hours * 60) || 0;
  return { hours, minutes };
};
